import { render, staticRenderFns } from "./CUFizicka.vue?vue&type=template&id=6aff3e40&"
import script from "./CUFizicka.vue?vue&type=script&lang=js&"
export * from "./CUFizicka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports